import React from 'react';
import LegalLayout, { Section } from '../components/fancyplants/LegalLayout';

const PrivacyPolicy = () => (
  <LegalLayout
    eyebrow="Legal"
    title="Privacy Notice"
    intro="We only collect what we need to get your plants to you and to run the shop properly. Here's exactly what that means."
    updated="May 2026"
  >
    <Section heading="Who we are">
      <p>
        Fancy Plants is a small plant shop based in the Irish midlands. We are the data
        controller for the personal data described here. Questions or requests about your data?
        Email <a href="mailto:hello@fancyplants.ie" className="link-underline">hello@fancyplants.ie</a>.
      </p>
    </Section>

    <Section heading="What we collect and why">
      <ul>
        <li><strong>Order details</strong> (name, email, delivery address, Eircode, order contents) — to take payment, pack and deliver your order, and provide support.</li>
        <li><strong>Account details</strong> (email, name, wishlist) — if you choose to create an account. You don't have to; guest checkout is always available.</li>
        <li><strong>Marketing preferences</strong> (email, consent) — only if you opt in to our seasonal newsletter or a "notify me when back in stock" alert.</li>
        <li><strong>Site usage</strong> (basic analytics) — only with your consent via the cookie banner.</li>
      </ul>
    </Section>

    <Section heading="Our lawful bases">
      <ul>
        <li><strong>Contract</strong> — processing your order and providing customer support.</li>
        <li><strong>Consent</strong> — marketing emails and back-in-stock alerts, and non-essential cookies. You can withdraw consent at any time.</li>
        <li><strong>Legal obligation</strong> — keeping order and tax records for the period required by law.</li>
      </ul>
    </Section>

    <Section heading="Who processes your data for us">
      <p>We use carefully chosen service providers (processors) under data-processing agreements:</p>
      <ul>
        <li><strong>Stripe</strong> — secure payment processing. Your full card details never reach us.</li>
        <li><strong>Firebase (Google)</strong> — account authentication.</li>
        <li><strong>Our email provider</strong> — order confirmations and, if you opt in, newsletters.</li>
        <li><strong>Our hosting &amp; CDN</strong> — to serve the website and images.</li>
      </ul>
    </Section>

    <Section heading="How long we keep it">
      <p>
        Order records are kept for as long as we're legally required to (typically several years
        for tax). Marketing data is kept until you unsubscribe. Account data is kept until you ask
        us to close your account.
      </p>
    </Section>

    <Section heading="Your rights">
      <p>
        Under the GDPR you can access, correct, delete or port your data, object to processing, or
        withdraw consent. To exercise any of these, email{' '}
        <a href="mailto:hello@fancyplants.ie" className="link-underline">hello@fancyplants.ie</a>.
        You also have the right to lodge a complaint with the Irish Data Protection Commission
        (<a href="https://www.dataprotection.ie" className="link-underline" target="_blank" rel="noreferrer">dataprotection.ie</a>).
      </p>
    </Section>
  </LegalLayout>
);

export default PrivacyPolicy;
